module.exports = __webpack_public_path__ + "static/media/tagDark.b08090ca.svg";